import React from 'react'
import { Card, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import * as IoIcons from 'react-icons/io'
import '../../assets/css/stylesheets/components/card/PriceCard.css'

function PriceCard({planName, price, frequency, description, benefits, planCode}) {
    return (
        <Card className='pricecard slide-in-fwd-bottom'>
            <div className='pricecard-header'>
                <h4>{planName}</h4>
                <h1>{price}</h1>
                <p>{frequency}</p>
                <Link to={`/signup/${planCode}`}>
                    <Button className='pricecard-header-button  pricingplans-card-header-button'>Purchase</Button>
                </Link>
                <div className='pricecard-seperator'></div>
            </div>
            <Card.Body>
                <div className='pricecard-body'>
                    <h5>{description}</h5>
                    <ul>
                        {
                            benefits.map((benefit, index) => {
                                return(
                                    <li key={index}>
                                        <IoIcons.IoMdCheckmark className='pricecard-body-icon' />
                                        {benefit}
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </Card.Body>
        </Card>
    )
}

export default PriceCard